export function listAgeCategory(params) {
    return window.axios.post("api/ageCategory/list", params)
}

export function deleteAgeCategory(id) {
    return window.axios.post("api/ageCategory/delete", {id: id})
}

export function updateAgeCategory(params) {
    return window.axios.post("api/ageCategory/update", params)
}

export function addAgeCategory(params) {
    return window.axios.post("api/ageCategory/add", params)
}

export function getAgeCategory(id) {
    return window.axios.post("api/ageCategory/get", {id: id})
}

export function exportAgeCategoryConfig() {
    return window.axios.post("api/ageCategory/exportConfig", {})
}

export function exportAgeCategory(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/ageCategory/export/excel", params, config)
}
